module.exports = __webpack_public_path__ + "media/alert-critical-1.87dc6e28.mp3";